const inititalState = { selectedTheme: "dark-standard", };
const changeThemeReducer = (state = inititalState, action) => {
  switch (action.type) {
    case "CHANGETHEME": {
      return { ...state, selectedTheme: action.payload };
    }
  }
  return state;
};
export default changeThemeReducer;